import { SITEKEY } from '../constants/DotEnv';

const SCRIPT_ID = 'google-recaptcha-enterprise';
const SCRIPT_URL = `https://www.google.com/recaptcha/enterprise.js?render=${SITEKEY}`;

let loaderPromise = null;

const resolveEnterprise = (resolve, reject) => {
    const { grecaptcha } = window;
    if (!grecaptcha || !grecaptcha.enterprise) {
        loaderPromise = null;
        reject(new Error('Google reCAPTCHA Enterprise unavailable on window.'));
        return;
    }
    grecaptcha.enterprise.ready(() => resolve(grecaptcha.enterprise));
};

export const loadRecaptcha = () => {
    if (typeof window === 'undefined') {
        return Promise.reject(new Error('Google reCAPTCHA Enterprise requires a browser environment.'));
    }

    if (loaderPromise) {
        return loaderPromise;
    }

    loaderPromise = new Promise((resolve, reject) => {
        const onReady = () => resolveEnterprise(resolve, reject);
        const onError = () => {
            loaderPromise = null;
            reject(new Error('Failed to load Google reCAPTCHA Enterprise script.'));
        };

        if (window.grecaptcha && window.grecaptcha.enterprise) {
            onReady();
            return;
        }

        let script = document.getElementById(SCRIPT_ID);

        if (!script) {
            script = document.createElement('script');
            script.id = SCRIPT_ID;
            script.src = SCRIPT_URL;
            script.async = true;
            script.defer = true;
            script.addEventListener('load', () => {
                script.setAttribute('data-loaded', 'true');
                onReady();
            }, { once: true });
            script.addEventListener('error', onError, { once: true });
            document.head.appendChild(script);
            return;
        }

        script.addEventListener('load', onReady, { once: true });
        script.addEventListener('error', onError, { once: true });

        if (script.getAttribute('data-loaded') === 'true') {
            onReady();
        }
    });

    return loaderPromise;
};

export const executeRecaptcha = async (action) => {
    const enterprise = await loadRecaptcha();
    return enterprise.execute(SITEKEY, { action });
};
